import * as React from 'react';
import { Theme, makeStyles, createStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    paddingLeft: 0,
    paddingRight: 0,
    display: "flex",
    height: "100%",
    weight: "100%",
  }
}));

export const BulkExportBox: React.FC = props => {
  const classes = useStyles();
  return <div className={classes.root}>
    {props.children}
  </div>
};